import { IconButton, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import IconContainer from '../../Components/IconContainer';
import { BsToggleOnIcon, ToggleOffIcon } from '../../Components/Icons/Icons';
import { AppColors } from '../../Utils/helper/AppColors';
// import { Switch } from 'antd';

export default function IntegrationAppItem({ item, localSettingColors }) {
	const [isSwitch, setISSwitch] = useState(false);
	return (
		<Stack direction="row" alignItems="center" gap={2}>
			<IconContainer />
			<Stack>
				<Typography
					variant="subtitle1"
					sx={{
						cursor: item.onClick ? 'pointer' : 'default',
					}}
					onClick={() => {
						if (item.onClick) item.onClick();
					}}
				>
					{item?.name}
				</Typography>
				<Typography variant="subtitle2">{item?.description}</Typography>
			</Stack>
			<Stack flexShrink={0} direction="row" alignItems="center" gap={1} ml="auto">
				<Typography variant="subtitle1" fontSize={13}>
					Learn More
				</Typography>
				{/* <Switch size="default" /> */}
				<IconButton onClick={() => setISSwitch(!isSwitch)} size="small">
					{isSwitch ? (
						<BsToggleOnIcon color={localSettingColors.fontColor} size={30} />
					) : (
						<ToggleOffIcon color={localSettingColors.fontColor} size={30} />
					)}
				</IconButton>
			</Stack>
		</Stack>
	);
}
